import { createFileRoute, redirect } from '@tanstack/react-router';

import { ActivityTimeline } from '@/features/activity-timeline/activity-timeline';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/activity-timeline/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: ActivityTimeline,
});
